import LoginRegister from "../components/LoginRegister/Main.vue";
export default [
  {
    path: "/",
    name: "HomePage",
    component: () => import("../components/HomePage/Main.vue"),
  },
  {
    path: "/market",
    name: "Market",
    component: () => import("../components/PublicPages/Market.vue"),
  },
  {
    path: "/fee",
    name: "Fee",
    component: () => import("../components/PublicPages/Fee.vue"),
  },
  {
    path: "/privacyandpolicy",
    name: "PrivacyAndPolicy",
    component: () => import("../components/PublicPages/PrivacyAndPolicy.vue"),
  },
  {
    path: "/aboutus",
    name: "AboutUs",
    component: () => import("../components/PublicPages/AboutUs.vue"),
  },
  {
    path: "/faq",
    name: "Faq",
    component: () => import("../components/PublicPages/Faq.vue"),
  },
  {
    path: "/contactus",
    name: "ContactUs",
    component: () => import("../components/PublicPages/ContactUs.vue"),
  },
  {
    path: "/signup",
    name: "SignUp",
    component: LoginRegister,
  },
  {
    path: "/login",
    name: "Login",
    component: LoginRegister,
  },
  {
    path: "/otpform/:authType",
    name: "OtpForm",
    component: LoginRegister,
    props: true,
  },
  {
    path: "/forgetpass",
    name: "ForgetPass",
    component: LoginRegister,
  },
  {
    path: "/otpforgetpass/:authType",
    name: "OtpForgetPass",
    component: LoginRegister,
    props: true,
  },
  {
    path: "/newpass",
    name: "NewPass",
    component: LoginRegister,
  },
  {
    path: "/advancetrade/:tradeTo/:tradeFrom",
    name: "AdvanceTrade",
    props: true,
    component: () => import("../components/P2P/Main.vue"),
  },
  {
    path: "/advancetrade",
    redirect: "/advancetrade/TOMAN/BITCOIN",
  },
  {
    path: "/redirect-from-bank",
    redirect: "/dashboard/redirect-from-bank",
  },

  {
    path: "/dashboard",
    // name:'Dashboard',
    component: () => import("../components/Panel/Main.vue"),
    children: [
      {
        path: "redirect-from-bank",
        name: "RedirectFromBank",
        component: () => import("../components/Panel/RedirectFromBank"),
      },
      {
        path: "otc",
        name: "OTC",
        props: true,
        component: () => import("../components/OTC/OTC.vue"),
      },
      {
        path: "",
        name: "Dashboard",
        component: () => import("../components/Panel/Dashboard/Dashboard.vue"),
      },
      {
        path: "history",
        name: "History",
        component: () => import("../components/Panel/History/MainHistory.vue"),
      },
      {
        path: "notifications",
        name: "Notifications",
        component: () =>
          import("../components/Panel/Notifications/Notifications.vue"),
      },
      {
        path: "invitefriends",
        name: "InviteFriends",
        component: () =>
          import("../components/Panel/InviteFriends/InviteFriends.vue"),
      },
      {
        path: "settings",
        name: "Settings",
        component: () => import("../components/Panel/Setting/Settings.vue"),
      },
      {
        path: "wallet",
        name: "Wallet",
        component: () => import("../components/Panel/Wallet/Wallet.vue"),
      },
      {
        path: "deposit-coin/:coin",
        name: "DepositCrypto",
        component: () => import("../components/Panel/Wallet/CoinDeposit.vue"),
        props: true,
      },
      {
        path: "rial-deposit",
        name: "RialDeposite",
        component: () => import("../components/Panel/Wallet/RialDeposit.vue"),
      },
      {
        path: "finotech",
        name: "FinoTech",
        component: () => import("../components/Panel/Account/KYC.vue"),
      },
      {
        path: "rial-withdrawal",
        name: "RialWithDrawal",
        component: () =>
          import("../components/Panel/Wallet/RialWithdrawal.vue"),
      },
      {
        path: "withdrawal-coin/:coin",
        name: "CryptoWithDrawal",
        component: () =>
          import("../components/Panel/Wallet/CoinWithdrawal.vue"),
        props: true,
      },
      {
        path: "account",
        name: "Account",
        component: () => import("../components/Panel/Account/Main.vue"),
      },
      {
        path: "/fromgoogle",
        name: "FromGoogle",
        component: () => import("../components/Tools/FromGoogle.vue"),
      },

      {
        path: "validation",
        name: "Validation",
        component: () => import("../components/Panel/Account/Main.vue"),
      },
      {
        path: "support",
        name: "Support",
        component: () => import("../components/Panel/Support/Support.vue"),
      },
      {
        path: "support/massage/:id",
        name: "SupportMassage",
        component: () =>
          import("../components/Panel/Support/SupportMassage.vue"),
        props: true,
      },
    ],
  },
  {
    path: "*",
    redirect: "/",
  },
];
